module.exports = __webpack_public_path__ + "static/media/mergecity-app_2screen.306f83ba.png";